import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// material
import { List, FormControl, InputBase, MenuItem, Select, styled } from '@mui/material';
// routes
import { PATH_CHAT } from 'src/routes/paths';
// redux
import { useDispatch } from 'src/redux/store';
import {
  getChatsAtendimento,
  getChatsPendente,
  getMessagesWhatsapp,
  getChatsGeral,
  getChatInfoByChatId,
  getCountsChats,
  getChatsFinalizados,
  getMensagensWhatsappDb,
  setChatInfo,
  removeChatFromList
} from 'src/redux/slices/chat';

// actions only 
import getActionChatByChatId from 'src/actions/chats/getActionChatByChatId';
import getActionAceitarChat from 'src/actions/chats/getActionAceitarChat';
import useAuth from 'src/hooks/useAuth';
import getActionFinalizarChat from 'src/actions/chats/getActionFinalizarChat';
import { useState } from 'react';
import ChatAtendimentoItem from '../ChatsListItem/ChatAtendimentoItem';
import { Button } from 'src/@/components/ui/button';
import Iconify from 'src/components/Iconify';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { Checkbox } from 'src/@/components/ui/checkbox';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'src/@/components/ui/accordion';
import { verifyRules } from 'src/utils/functions';
import v2_actionFinalizarMultiplosChats from 'src/actions/v2/chats/v2_actionFinalizarMultiplosChats';
import { useSnackbar } from 'notistack';

ChatConversationListGeral.propTypes = {
  isOpenSidebar: PropTypes.bool,
};

const CompactInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(1),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: '#ffffff',
    border: '1px solid #d1d5db',
    fontSize: 12,
    padding: '4px 8px',
    color: '#374151',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      borderColor: '#9ca3af',
    },
    '&:focus': {
      borderColor: '#3b82f6',
      boxShadow: '0 0 0 1px #3b82f6',
    },
    '&::placeholder': {
      color: '#9ca3af',
      opacity: 1,
    },
  },
}));

export default function ChatConversationListGeral({ 
  chats, 
  chat, 
  isOpenSidebar, 
  cliente,
  listaTagsReduce,
  listaCanaisReduce,
  tagsSelecionadas,
  canaisSelecionados,
  chatsNaoLidos,
  changeTags,
  changeCanais,
  changeChatsNaoLidos,
  limparFiltro,
  isFiltered,
  ...other 
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const { conversationKey } = useParams();
  const { t } = useTranslation('chat');
  const [loadingFinalizarChat, setLoadingFinalizarChat] = useState(false)
  const [loadingAceitarChat, setLoadingAceitarChat] = useState(false)
  const [keyFinalizarChat, setKeyFinalizarChat] = useState('');
  const [visibleItems, setVisibleItems] = useState(10);
  const [loadingLimparChats, setLoadingLimparChats] = useState(false);
  const [openModalConfimacao, setOpenModalConfimacao] = useState(false);

  const loadMoreItems = () => {
    setVisibleItems((prev) => prev + 10);
  };

  // Função para aplicar filtros
  const applySortFilter = ({
    tableData,
    tagsSelecionadas,
    canaisSelecionados,
    chatsNaoLidos
  }) => {
    // Se não há filtros selecionados, retorna os dados originais
    if ((!tagsSelecionadas || tagsSelecionadas.length === 0) && 
        (!canaisSelecionados || canaisSelecionados.length === 0) && 
        (!chatsNaoLidos || chatsNaoLidos.length === 0)) {
      return tableData || [];
    }

    let filteredData = [];

    function mapStatus(status) {
      // Supports both pt-BR and en label values from sidebar filter
      const statusMap = {
        "Chats não lidos": "sim",
        "Chats lidos": "nao",
        "Unread chats": "sim",
        "Read chats": "nao"
      };
      return statusMap[status] || status;
    }

    const chatsNaoLidoMapped = (chatsNaoLidos || []).map(mapStatus);
    let currentData = [...(tableData || [])];

    if (tagsSelecionadas && tagsSelecionadas.length > 0) {
      filteredData = [];
      currentData.forEach((item) => {
        if (item.tags_ids && Array.isArray(item.tags_ids)) {
          const filteredTags = item.tags_ids.filter((tag) => tagsSelecionadas.includes(tag.nome));
          if (filteredTags.length > 0) {
            filteredData.push(item);
          }
        }
      });
      currentData = filteredData;
    }

    if (canaisSelecionados && canaisSelecionados.length > 0) {
      filteredData = [];
      currentData.forEach((item) => {
        if (canaisSelecionados.includes(item.nome_canal)) {
          filteredData.push(item);
        }
      });
      currentData = filteredData;
    }

    if (chatsNaoLidos && chatsNaoLidos.length > 0) {
      filteredData = [];
      currentData.forEach((item) => {
        if (chatsNaoLidoMapped.includes(item.novaMensagem)) {
          filteredData.push(item);
        }
      });
      currentData = filteredData;
    }

    return currentData;
  };

  const dataFiltered = applySortFilter({
    tableData: chats || [],
    tagsSelecionadas: tagsSelecionadas || [],
    canaisSelecionados: canaisSelecionados || [],
    chatsNaoLidos: chatsNaoLidos || []
  });

  async function limparChats() {
    try {
      let data = {
        usuarioId: user.id,
        status: 'Geral',
        clienteId: cliente._id,
      };
      setLoadingLimparChats(true);
      const result = await v2_actionFinalizarMultiplosChats(data);
      if (!result.data.error) {
        dispatch(getChatsGeral(user.clienteId, user.id, user.setorId, 100, true));
        dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
      }
      setLoadingLimparChats(false);
      enqueueSnackbar(t('sidebar.chatsFinalized'), { variant: 'success' });
    } catch (error) {
      setLoadingLimparChats(false);
      console.log(error);
      enqueueSnackbar(t('sidebar.clearChatsError'), { variant: 'error' });
    }
  }


  const handleSelectConversation = (chat) => {
    if (cliente.config.chat_source_db) {
      dispatch(getMensagensWhatsappDb(chat.sessao, chat.numeroCliente));
    } else {
      dispatch(getMensagensWhatsappDb(chat.sessao, chat.numeroCliente));
    }
    if (chat) {
      dispatch(setChatInfo(chat));
    } else {
      dispatch(getChatInfoByChatId(chat._id, chat.funil_id, user.id, true));
    }

  };

  const handleFinalizarChat = async (chat) => {
    setKeyFinalizarChat(chat._id)
    setLoadingFinalizarChat(true)
    let data = {
      chatId: chat._id,
      usuarioId: user.id
    };
    try {
      await getActionFinalizarChat(data);
      dispatch(getChatsGeral(user.clienteId, user.id, user.setorId, 50, true));
      dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 50, true));
      // dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
      setLoadingFinalizarChat(false);
      setKeyFinalizarChat('');
      if (chat._id === conversationKey) return navigate(`${PATH_CHAT.chat.root}`);

    } catch (error) {
      setLoadingFinalizarChat(false)
      setKeyFinalizarChat('')
      console.log("Erro ao finalizar chat");
    }


  };



  const handleAceitar = async (chatId) => {
    setLoadingAceitarChat(true)
    const res_chat = await getActionChatByChatId({ chatId: chatId });
    if (res_chat.data.statusRoom !== 'Atendendo') {
      try {
        dispatch(removeChatFromList({ chatId: chatId, status: 'Geral' }))
        await getActionAceitarChat({ chatId: chatId, usuarioId: user.id });
        setLoadingAceitarChat(false);
        dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
        dispatch(getChatsGeral(user.clienteId, user.id, user.setorId, 100, false));
        dispatch(getChatsPendente(user.clienteId, user.id, user.setorId));
        handleSelectConversation(chat)
      } catch (error) {
        setLoadingAceitarChat(false)
      }
    }
  };

  return (
    <List {...other}>
      {dataFiltered.slice(0, visibleItems).map((chat) => (
        <ChatAtendimentoItem
          key={chat._id}
          chat={chat}
          keyFinalizarChat={keyFinalizarChat}
          loadingFinalizarChat={loadingFinalizarChat}
          isOpenSidebar={isOpenSidebar}
          onFinalizarChat={() => handleFinalizarChat(chat)}
          onAceitarChat={() => handleAceitar(chat._id)}
          onSelectConversation={() => handleSelectConversation(chat)}
        />
      ))}
      {visibleItems < dataFiltered.length && (
        <Button className="w-full bg-pink-800 hover:bg-violet-600 text-white" onClick={loadMoreItems} fullWidth>
          {t('list.loadMore')}
        </Button>
      )}
    </List>
  );
}
